<template>
  <div id="app">
    <sui-menu>
      <sui-menu-item><img src="./assets/logo.png"/></sui-menu-item>
      <router-link to="/" v-slot="{ href }"><sui-menu-item header :href="href" :link="true">Cloud Splash Console</sui-menu-item></router-link>
      <router-link to="/about" v-slot="{ href, isExactActive }"><sui-menu-item :href="href" :link="true" :active="isExactActive">About</sui-menu-item></router-link>
      <sui-menu-item v-if="isLoggedInUser" position="right">
        Hi, <span id="user-id">{{userId}}</span><sui-button @click="signOut">登出</sui-button>
      </sui-menu-item>
    </sui-menu>
    <sui-container>
      <router-view></router-view>
    </sui-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'App',
  computed: {
    ...mapState([
      'isLoggedInUser',
      'userId',
      'isAdmin',
    ]),
  },
  async mounted() {
    if (this.isAdmin === undefined) {
      this.fetchUserData();
    }
  },
  methods: {
    async signOut () {
      await firebase.auth().signOut();
      const redirect_url = location.href.split('#')[0];
      if (redirect_url) {
        const authUrl = 'https://auth.ezcast.com/v2/logout';
        location.href = `${authUrl}?redirect_url=${encodeURIComponent(redirect_url)}`;
      } else {
        window.location.reload();
      }
    },
    ...mapActions([
      'fetchUserData',
    ]),
  },
}
</script>

<style>
#user-id {
  user-select: text;
  margin-right: 1rem;
  color: rgb(0, 183, 255);
}
</style>
